import { SelectOptionTypes } from "../../../../components/Input";

export const FORM_ID = "set-interest-rate";

// Values are months so they map straight onto the API's numeric `resetFrequency`.
export const RESET_FREQUENCY_OPTIONS = [
  { label: "Every 3 months", value: "3" },
  { label: "Every 6 months", value: "6" },
  { label: "Every 12 months", value: "12" },
  { label: "Every 2 years", value: "24" },
  { label: "Every 5 years", value: "60" },
] as SelectOptionTypes[];

export const RATE_APPLIES_NOTE =
  "The new rate applies from its effective date and computes the amortization schedule going forward.";

export const PAYMENT_AMOUNT_NOTE =
  "If not specified, a suggested payment amount will be estimated from the rate, remaining balance, and remaining payments.";
